const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/sms/adapter-config.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { AdapterConfigParamSchema } from '@apps/main/features/admin/pages/sms/adapter-config-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/sms/adapter-config')({
  validateSearch: AdapterConfigParamSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});